import { render } from "./SportsStoreEditorPage.vue?vue&type=template&id=229e99d2"
import script from "./SportsStoreEditorPage.vue?vue&type=script&lang=js"
export * from "./SportsStoreEditorPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__